import { createTypes } from 'reduxsauce'
 
export default createTypes(`
	FETCH_USER
  FETCH_USER_SUCCESS
  FETCH_USER_FAILURE

  UPDATE_USER
  UPDATE_USER_SUCCESS
  UPDATE_USER_FAILURE

  SAVE_USER
  SAVE_USER_SUCCESS
  SAVE_USER_FAILURE

  SAVE_USER_DETAILS

  CLEAR_STATE
 
`, {});
